import { constrainContentWidthRules } from "@wayflyer/flyui";
import { styled } from "styled-components";

const FooterWrapper = styled.footer<{ $constrainWidth?: boolean }>`
  margin-top: auto;

  &.constrainWidth {
    ${constrainContentWidthRules}
  }
`;

const DisclaimerSection = styled.div`
  flex: 2;
`;

const DisclaimerParagraph = styled.div`
  margin-bottom: 10px;
  min-width: 240px;
`;

const StyledIcon = styled.span`
  display: flex;
  align-items: center;
`;

export { DisclaimerParagraph, DisclaimerSection, FooterWrapper, StyledIcon };
